export const TEST_IDS = {
  // layout
  appHeader: "app-header",
  appTitle: "app-title",
  navBuild: "nav-build",
  navGalaxy: "nav-galaxy",
  navJournal: "nav-journal",
  navStudy: "nav-study",

  // search
  searchInput: "search-input",
  searchResults: "search-results",
  searchResultItem: (k) => `search-result-${k}`,

  // build path
  levelSelector: "level-selector",
  levelOption: (lvl) => `level-option-${lvl}`,
  stageCard: (s) => `stage-${s}`,
  pathKanji: (k) => `path-kanji-${k}`,

  // build tree
  buildTree: "build-tree",
  buildNode: (k) => `build-node-${k}`,
  buildUsedIn: (k) => `build-usedin-${k}`,

  // on-yomi galaxy
  galaxyModeReading: "galaxy-mode-reading",
  galaxyModeKanji: "galaxy-mode-kanji",
  galaxyPhoneticToggle: "galaxy-phonetic-toggle",
  galaxyReadingSelect: "galaxy-reading-select",
  galaxyReadingOption: (r) => `galaxy-reading-${r}`,
  galaxyKanji: (k) => `galaxy-kanji-${k}`,
  galaxyCenter: "galaxy-center",

  // focus page
  focusPage: "focus-page",
  focusBack: "focus-back",
  focusToggleCompounds: "focus-toggle-compounds",
  focusKanji: "focus-kanji",
  focusMeaning: "focus-meaning",
  focusOn: "focus-on",
  focusKun: "focus-kun",
  focusBuiltFrom: "focus-built-from",
  focusComponent: (k) => `focus-component-${k}`,
  focusUsedIn: "focus-used-in",
  focusUsedInChip: (k) => `focus-usedin-${k}`,
  focusPhonetic: "focus-phonetic",
  focusTreeContainer: "focus-tree-container",
  focusTreeNode: (k) => `focus-tree-node-${k}`,
  focusCompound: (w) => `focus-compound-${w}`,

  // drawer (legacy)
  drawer: "kanji-drawer",
  drawerClose: "drawer-close",
  drawerKanji: "drawer-kanji",
  drawerMeaning: "drawer-meaning",
  drawerOn: "drawer-on",
  drawerKun: "drawer-kun",
  drawerStrokes: "drawer-strokes",
  drawerJlpt: "drawer-jlpt",
  drawerBuiltFrom: "drawer-built-from",
  drawerUsedIn: "drawer-used-in",
  drawerComponent: (k) => `drawer-component-${k}`,
  drawerUsedInChip: (k) => `drawer-usedin-chip-${k}`,
  drawerPhonetic: "drawer-phonetic",

  // mnemonic editor
  mneEditor: "mnemonic-editor",
  mneTextarea: "mnemonic-textarea",
  mneSave: "mnemonic-save",
  mneDelete: "mnemonic-delete",

  // progress
  progressKnown: "progress-known",
  progressLearning: "progress-learning",
  progressNew: "progress-new",
};
